import { render, staticRenderFns } from "./packing-batch-manager.vue?vue&type=template&id=3190947a&scoped=true"
import script from "./packing-batch-manager.vue?vue&type=script&lang=ts"
export * from "./packing-batch-manager.vue?vue&type=script&lang=ts"
import style0 from "./packing-batch-manager.vue?vue&type=style&index=0&id=3190947a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3190947a",
  null
  
)

export default component.exports